import * as R from 'ramda'
import { load_many } from '@/store/action-helpers'

export default {

    loadAllByVariantId: load_many('variants/:variantId/fields'),

    loadAllByVariantIds({ dispatch }, { variantIds }) {
        return R.compose(

            promises => Promise.all(promises),

            R.map(variantId => dispatch('loadAllByVariantId', { variantId }))

        )(variantIds)
    },

    loadAllByVariantModels({ dispatch }, { variantModels }) {
        return R.compose(

            variantIds => dispatch('loadAllByVariantIds', { variantIds }),

            R.map(R.prop('id'))

        )(variantModels)
    }

}
